AFRAME.registerComponent('panel-look-center', {
    schema: {
        enabled: {type: 'boolean', default: false}  // Enabled flag
    },

    init: function () {
        this.sceneEl = this.el.sceneEl;  // Cache scene element
        this.initializePanels();  // Set up panels with positions and rotations
        this.lastEnabled = this.data.enabled;  // Track previous enabled state
        this.targetState = 'none';  // Target state for transitions

        this.cameraRig = document.querySelector('[camera-rig-handler-v3]');
        if (!cameraRig) {
            console.error('Camera rig not found!');
            return;
        }
    },

    initializePanels: function () {
        this.leftPanel = document.getElementById('large-left-panel');
        this.centerPanel = document.getElementById('large-center-panel');
        this.rightPanel = document.getElementById('large-right-panel');
        this.topCenterPanel = document.getElementById('small-center-panel');
        this.dock = document.getElementById('dock');
        this.camera = document.getElementById('camera');


        // Original positions and rotations
        this.leftOriginalPos = this.leftPanel.getAttribute('position').clone();
        this.centerOriginalPos = this.centerPanel.getAttribute('position').clone();
        this.rightOriginalPos = this.rightPanel.getAttribute('position').clone();
        this.topCenterOriginalPos = this.topCenterPanel.getAttribute('position').clone();
        this.dockOriginalPos = this.dock.getAttribute('position').clone();

        this.leftOriginalRot = this.leftPanel.getAttribute('rotation') || {x: 0, y: 0, z: 0};
        this.centerOriginalRot = this.centerPanel.getAttribute('rotation') || {x: 0, y: 0, z: 0};
        this.rightOriginalRot = this.rightPanel.getAttribute('rotation') || {x: 0, y: 0, z: 0};
        this.topCenterOriginalRot = this.topCenterPanel.getAttribute('rotation') || {x: 0, y: 0, z: 0};

        // Closer positions (z offset matches centerCloserPos: original.z + 1)
        this.leftCloserPos = {
            x: this.leftOriginalPos.x + .3,
            y: this.leftOriginalPos.y,
            z: this.centerOriginalPos.z + 1
        };
        this.centerCloserPos = {
            x: this.centerOriginalPos.x,
            y: this.centerOriginalPos.y,
            z: this.centerOriginalPos.z + 1
        };
        this.rightCloserPos = {
            x: this.rightOriginalPos.x - .3,
            y: this.rightOriginalPos.y,
            z: this.centerOriginalPos.z + 1
        };
        this.dockCloserPos = {
            x: this.dockOriginalPos.x,
            y: this.dockOriginalPos.y,
            z: this.dockOriginalPos.z + 1
        };
        this.topCenterCloserPos = {
            x: this.topCenterOriginalPos.x,
            y: this.topCenterOriginalPos.y,
            z: this.topCenterOriginalPos.z + 1
        };

        // Closer rotations (adjust as needed)
        // this.leftCloserRot = {x: 0, y: 20, z: 0};
        // this.centerCloserRot = {x: 0, y: 0, z: 0};
        // this.rightCloserRot = {x: 0, y: -20, z: 0};
        // this.topCenterCloserRot = { x: 20, y: 0, z: 0 };  // Tilt up to face user

        this.currentState = 'none';  // Start with no panel centered

        // Set all panels to original positions and rotations at initialization
        // this.leftPanel.setAttribute('position', this.leftOriginalPos);
        // this.centerPanel.setAttribute('position', this.centerOriginalPos);
        // this.rightPanel.setAttribute('position', this.rightOriginalPos);
        // this.topCenterPanel.setAttribute('position', this.topCenterOriginalPos);

        // this.leftPanel.setAttribute('rotation', this.leftOriginalRot);
        // this.centerPanel.setAttribute('rotation', this.centerOriginalRot);
        // this.rightPanel.setAttribute('rotation', this.rightOriginalRot);
        // this.topCenterPanel.setAttribute('rotation', this.topCenterOriginalRot);
    },


    tick: function () {
        if (!this.camera) return;

        const isVR = this.sceneEl.is('vr-mode');  // Check VR mode directly
        const wasEnabled = this.lastEnabled;
        this.lastEnabled = this.data.enabled;

        if (isVR) {
            if (!wasEnabled && this.data.enabled) {
                // Transition from !enabled to enabled: re-initialize panels
                this.initializePanels();
                this.leftPanel.setAttribute('class', 'billboard');
                this.rightPanel.setAttribute('class', 'billboard');
                console.info('Setting billboard on panels.');
                cameraRig.emit('reset-camera', { message: 'far'});

                // this.leftPanel.setAttribute( 'billboard','');
                // this.rightPanel.setAttribute('billboard','');
                this.currentState = 'none';  // Reset state to trigger initial transition
            }

            if (this.data.enabled) {
                // Determine target state based on head rotation
                const yaw = this.camera.object3D.rotation.y * (180 / Math.PI);
                const pitch = this.camera.object3D.rotation.x * (180 / Math.PI);
                const normalizedYaw = yaw % 360 > 180 ? yaw % 360 - 360 : yaw % 360;
                const normalizedPitch = pitch % 360 > 180 ? pitch % 360 - 360 : pitch % 360;

                let newTargetState = this.currentState;
                // if (normalizedPitch > 10) {
                // newTargetState = 'center';
                if (normalizedYaw < -15) {
                    newTargetState = 'right';
                } else if (normalizedYaw > 15) {
                    newTargetState = 'left';
                } else if (normalizedYaw >= -5 && normalizedYaw <= 5) {
                    newTargetState = 'center';
                }

                // Only transition if the state changes
                if (newTargetState !== this.currentState) {
                    this.targetState = newTargetState;
                    this.transitionToState(this.targetState);
                }
            } else if (isVR && wasEnabled && !this.data.enabled) {
                // Reset to original positions and rotations when toggled off in VR
                if (this.currentState !== 'none') {
                    this.targetState = 'none';
                    // this.leftPanel.removeAttribute('class');
                    // this.rightPanel.removeAttribute('class');
                    this.resetToOriginal();
                }
            }
        }
    },

    transitionToState: function (state) {
        switch (state) {
            case 'center':
                this.transitionToCenter();
                break;
            case 'left':
                this.transitionToLeft();
                break;
            case 'right':
                this.transitionToRight();
                break;
            // case 'top-center':
            //     this.transitionToTopCenter();
            //     break;
            default:
                console.warn('Unknown state:', state);
        }
        cameraRig.emit('update-billboards');
    },

    transitionToCenter: function () {
        console.log('Transitioning to center');
        this.dock.setAttribute('animation__position', {
            property: 'position',
            to: `${this.dockCloserPos.x} ${this.dockCloserPos.y} ${this.dockCloserPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        this.centerPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.centerCloserPos.x} ${this.centerCloserPos.y} ${this.centerCloserPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.centerPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.centerCloserRot.x} ${this.centerCloserRot.y} ${this.centerCloserRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.leftPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.leftOriginalPos.x} ${this.leftOriginalPos.y} ${this.leftOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.leftPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.leftOriginalRot.x} ${this.leftOriginalRot.y} ${this.leftOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.rightPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.rightOriginalPos.x} ${this.rightOriginalPos.y} ${this.rightOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.rightPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.rightOriginalRot.x} ${this.rightOriginalRot.y} ${this.rightOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.topCenterPanel.setAttribute('animation__position', {
        //     property: 'position',
        //     to: `${this.topCenterOriginalPos.x} ${this.topCenterOriginalPos.y} ${this.topCenterOriginalPos.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.topCenterPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.topCenterCloserPos.x} ${this.topCenterCloserPos.y} ${this.topCenterCloserPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        this.currentState = 'center';
    },
    transitionToLeft: function () {
        console.log('Transitioning to left');
        this.leftPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.leftCloserPos.x} ${this.leftCloserPos.y} ${this.leftCloserPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.leftPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.leftCloserRot.x} ${this.leftCloserRot.y} ${this.leftCloserRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.centerPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.centerOriginalPos.x} ${this.centerOriginalPos.y} ${this.centerOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.centerPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.centerOriginalRot.x} ${this.centerOriginalRot.y} ${this.centerOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.rightPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.rightOriginalPos.x} ${this.rightOriginalPos.y} ${this.rightOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.rightPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.rightOriginalRot.x} ${this.rightOriginalRot.y} ${this.rightOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.topCenterPanel.setAttribute('animation__position', {
        //     property: 'position',
        //     to: `${this.topCenterOriginalPos.x} ${this.topCenterOriginalPos.y} ${this.topCenterOriginalPos.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.topCenterPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.topCenterOriginalRot.x} ${this.topCenterOriginalRot.y} ${this.topCenterOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.currentState = 'left';
    }
    ,

    transitionToRight: function () {
        console.log('Transitioning to right');
        this.rightPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.rightCloserPos.x} ${this.rightCloserPos.y} ${this.rightCloserPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.rightPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.rightCloserRot.x} ${this.rightCloserRot.y} ${this.rightCloserRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.centerPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.centerOriginalPos.x} ${this.centerOriginalPos.y} ${this.centerOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.centerPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.centerOriginalRot.x} ${this.centerOriginalRot.y} ${this.centerOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.leftPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.leftOriginalPos.x} ${this.leftOriginalPos.y} ${this.leftOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.leftPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.leftOriginalRot.x} ${this.leftOriginalRot.y} ${this.leftOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.topCenterPanel.setAttribute('animation__position', {
        //     property: 'position',
        //     to: `${this.topCenterOriginalPos.x} ${this.topCenterOriginalPos.y} ${this.topCenterOriginalPos.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.topCenterPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.topCenterOriginalRot.x} ${this.topCenterOriginalRot.y} ${this.topCenterOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.currentState = 'right';
    }
    ,

    transitionToTopCenter: function () {
        console.log('Transitioning to top-center');
        // this.topCenterPanel.setAttribute('animation__position', {
        //     property: 'position',
        //     to: `${this.topCenterCloserPos.x} ${this.topCenterCloserPos.y} ${this.topCenterCloserPos.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.topCenterPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.topCenterCloserRot.x} ${this.topCenterCloserRot.y} ${this.topCenterCloserRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.centerPanel.setAttribute('animation__position', {
        //     property: 'position',
        //     to: `${this.centerOriginalPos.x} ${this.centerOriginalPos.y} ${this.centerOriginalPos.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.centerPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.centerOriginalRot.x} ${this.centerOriginalRot.y} ${this.centerOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.leftPanel.setAttribute('animation__position', {
        //     property: 'position',
        //     to: `${this.leftOriginalPos.x} ${this.leftOriginalPos.y} ${this.leftOriginalPos.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.leftPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.leftOriginalRot.x} ${this.leftOriginalRot.y} ${this.leftOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.rightPanel.setAttribute('animation__position', {
        //     property: 'position',
        //     to: `${this.rightOriginalPos.x} ${this.rightOriginalPos.y} ${this.rightOriginalPos.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        // this.rightPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.rightOriginalRot.x} ${this.rightOriginalRot.y} ${this.rightOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.currentState = 'top-center';
    }
    ,

    resetToOriginal: function () {
        console.log('Resetting all panels to original positions and rotations');
        // Set all panels to original positions and rotations at initialization
        // this.leftPanel.setAttribute('position', this.leftOriginalPos);
        // this.centerPanel.setAttribute('position', this.centerOriginalPos);
        // this.rightPanel.setAttribute('position', this.rightOriginalPos);
        // this.topCenterPanel.setAttribute('position', this.topCenterOriginalPos);
        // this.dock.setAttribute('position', this.dockOriginalPos);

        // this.leftPanel.setAttribute('rotation', this.leftOriginalRot);
        // this.centerPanel.setAttribute('rotation', this.centerOriginalRot);
        // this.rightPanel.setAttribute('rotation', this.rightOriginalRot);
        // this.topCenterPanel.setAttribute('rotation', this.topCenterOriginalRot);
        this.dock.setAttribute('animation__position', {
            property: 'position',
            to: `${this.dockOriginalPos.x} ${this.dockOriginalPos.y} ${this.dockOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });

        this.leftPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.leftOriginalPos.x} ${this.leftOriginalPos.y} ${this.leftOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.leftPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.leftOriginalRot.x} ${this.leftOriginalRot.y} ${this.leftOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.centerPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.centerOriginalPos.x} ${this.centerOriginalPos.y} ${this.centerOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.centerPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.centerOriginalRot.x} ${this.centerOriginalRot.y} ${this.centerOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.rightPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.rightOriginalPos.x} ${this.rightOriginalPos.y} ${this.rightOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.rightPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.rightOriginalRot.x} ${this.rightOriginalRot.y} ${this.rightOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });
        this.topCenterPanel.setAttribute('animation__position', {
            property: 'position',
            to: `${this.topCenterOriginalPos.x} ${this.topCenterOriginalPos.y} ${this.topCenterOriginalPos.z}`,
            dur: 350,
            easing: 'easeInOutQuad'
        });
        // this.topCenterPanel.setAttribute('animation__rotation', {
        //     property: 'rotation',
        //     to: `${this.topCenterOriginalRot.x} ${this.topCenterOriginalRot.y} ${this.topCenterOriginalRot.z}`,
        //     dur: 350,
        //     easing: 'easeInOutQuad'
        // });

        this.leftPanel.removeAttribute('class');
        // this.centerPanel.removeAttribute('class');
        this.rightPanel.removeAttribute('class');
        console.info('Unsetting billboard on panels.');

        updatePanelPositions(.65, 45, .85);

        this.currentState = 'none';
    }
});